module.exports = __webpack_public_path__ + "static/media/help.e4c8e5fc.svg";